import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetCategory from './met-category';
import MetCategoryDetail from './met-category-detail';
import MetCategoryUpdate from './met-category-update';
import MetCategoryDeleteDialog from './met-category-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetCategoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetCategoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetCategoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetCategory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetCategoryDeleteDialog} />
  </>
);

export default Routes;
